import React from 'react'
import { ChatContextConsumer } from '@deal/chat-firebase'
import { Link } from 'react-router-dom'
import InboxIcon from '#src/components/Header/StandardHeader/icons/mobile/inbox.svg'
import styles from './styles.css'

const InboxNavigation: React.FC = () => {
  return (
    <Link to="/inbox">
      <div className={styles.inbox}>
        <ChatContextConsumer>
          {({ unreadMessageCount }) => (
            <>
              {!!unreadMessageCount && <div className={styles.badge}>{unreadMessageCount}</div>}
              <InboxIcon className={styles.icon} />
            </>
          )}
        </ChatContextConsumer>
      </div>
    </Link>
  )
}

export default InboxNavigation
